<template>
    <div class="tab-year">
        <el-tabs v-model="year" type="card" @tab-click="handleTabClick">
            <el-tab-pane v-for="item in computedYearList" :key="item" :label="item + '考研'" :name="item"></el-tab-pane>
        </el-tabs>
    </div>

</template>


<script>
import { getYear } from "@/api/common";
export default {
    data() {
        return {
            internalYearList: [],
            year: ''
        };
    },
    props: ['queryYear', 'yearList'],
    computed: {
        // 计算属性：优先使用父组件传入的 yearList，否则使用内部的 internalYearList
        computedYearList() {
            return this.yearList && this.yearList.length > 0 ? this.yearList : this.internalYearList;
        }
    },
    watch: {
        // 监听父组件传入的 yearList 变化
        yearList: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.setDefaultYear();
                }
            },
            immediate: true
        },
        // 监听计算属性变化
        computedYearList: {
            handler(newVal) {
                if (newVal && newVal.length > 0 && !this.year) {
                    this.setDefaultYear();
                }
            },
            immediate: true
        }
    },
    created() {
        // 如果父组件没有传入 yearList 或为空，则通过 API 获取年份数据
        if (!this.yearList || this.yearList.length === 0) {
            getYear().then(res => {
                this.internalYearList = res.data;
                this.setDefaultYear();
            });
        }
    },
    methods: {
        handleTabClick(tab) {
            console.log(tab);
            this.$emit('func', tab.name);
            this.year = tab.name;
        },
        // 设置默认年份的方法
        setDefaultYear() {
            const availableYears = this.computedYearList;
            if (availableYears && availableYears.length > 0) {
                // 优先使用 queryYear，否则使用第一个年份
                const defaultYear = this.queryYear && availableYears.includes(this.queryYear) 
                    ? this.queryYear 
                    : availableYears[0];
                
                if (this.year !== defaultYear) {
                    this.year = defaultYear;
                    this.$emit('func', this.year);
                }
            }
        }
    }
};
</script>

